module.exports = __webpack_public_path__ + "img/end3.5424e2b9.svg";